import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
import { merge, Observable, of as observableOf, fromEvent, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { GithubApi, GithubIssue, UserList, UserLevel, UserStatus, UserCountry } from '../../../models/administration.model';
import { AdministrationService } from '../../../services/administration.service';
import { UserService } from '../../../services/user.service'
import { AddNewUserDialog } from '../../administration/user-list/dialog.addnewuser'

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  displayedColumns: string[] = ['Numero', 'CountryCode', 'UserLevel', 'UserId', 'UserEmail', 'UserStatus'];
  database: AdministrationService | null;
  data: UserList[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  selectedSearchType: string = '0';
  userName: string = '';
  screenCode: string = '';
  searchTypeList = [
    { value: '0', viewValue: '-Search Type-' },
    { value: '1', viewValue: 'User ID' },
    { value: '2', viewValue: 'E-Mail' },
    { value: '3', viewValue: 'User Level' },
    { value: '4', viewValue: 'Country' },
    { value: '5', viewValue: 'Status' }
  ];
  selectedUserLevel: string = '';
  selectedUserCountry: string = '';
  selectedUserStatus: boolean;
  email: string = '';
  userId: string = '';

  userLevel$: Observable<UserLevel[]>;
  userStatus$: Observable<UserStatus[]>;
  userCountry$: Observable<UserCountry[]>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;

  recordChange$ = new Subject();

  constructor(private http: HttpClient,
    private userService: UserService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.database = new AdministrationService(this.http);
    this.userLevel$ = this.database.getUserLevels();
    this.userStatus$ = this.database.getUserStatus();
    this.userCountry$ = this.database.getUserCountries();

    // If the user changes the sort order, reset back to the first page.
    // this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // merge(this.sort.sortChange, this.paginator.page)
    //   .pipe(
    //     startWith({}),
    //     switchMap(() => {
    //       this.isLoadingResults = true;
    //       return this.database!.getRepoIssues(
    //         this.sort.active, this.sort.direction, this.paginator.pageIndex);
    //     }),
    //     map(data => {
    //       // Flip flag to show that loading has finished.
    //       this.isLoadingResults = false;
    //       this.isRateLimitReached = false;
    //       this.resultsLength = data.total_count;

    //       return data.items;
    //     }),
    //     catchError(() => {
    //       this.isLoadingResults = false;
    //       // Catch if the GitHub API has reached its rate limit. Return empty data.
    //       this.isRateLimitReached = true;
    //       return observableOf([]);
    //     })
    //   ).subscribe(data => this.data = data);

    let init_sub = merge(this.paginator.page, this.recordChange$)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this.database!.getUserList({
            pageNumber: this.paginator.pageIndex + 1,
            SearchBy: this.selectedSearchType,
            SearchValue: this.getSearchValue()
          });
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.resultsLength = data.countUserList;

          return data.userLists;
        }),
        catchError(() => {
          this.isLoadingResults = false;

          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  searchUser() {
    this.paginator.pageIndex = 0;
    this.resetSearchValue();
    this.recordChange$.next();
  }

  getSearchValue() {
    let searchValue = '';

    switch (this.selectedSearchType) {
      case '1':
        searchValue = this.userId;
        break;
      case '2':
        searchValue = this.email;
        break;
      case '3':
        searchValue = this.selectedUserLevel;
        break;
      case '4':
        searchValue = this.selectedUserCountry;
        break;
      case '5':
        searchValue = this.selectedUserStatus ? '1' : '0';
        break;
      default:
        searchValue = '';
        break;
    }

    return searchValue;
  }

  resetSearchValue() {
    switch (this.selectedSearchType) {
      case '1':
        this.email = '';
        this.selectedUserLevel = '';
        this.selectedUserCountry = '';
        this.selectedUserStatus = null;
        break;
      case '2':
        this.userId = '';
        this.selectedUserLevel = '';
        this.selectedUserCountry = '';
        this.selectedUserStatus = null;
        break;
      case '3':
        this.userId = '';
        this.email = '';
        this.selectedUserCountry = '';
        this.selectedUserStatus = null;
        break;
      case '4':
        this.userId = '';
        this.email = '';
        this.selectedUserLevel = '';
        this.selectedUserStatus = null;
        break;
      case '5':
        this.userId = '';
        this.email = '';
        this.selectedUserLevel = '';
        this.selectedUserCountry = '';
        break;
      default:
        this.userId = '';
        this.email = '';
        this.selectedUserLevel = '';
        this.selectedUserCountry = '';
        this.selectedUserStatus = null;
        break;
    }
  }

  openAddNewUserDialog(): void {
    let dialogRef = this.dialog.open(AddNewUserDialog, {
      width: '50%',
      disableClose: true,
      data: { }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new user successful') {
        this.openSnackBar('New user added.', '');
        this.recordChange$.next();
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}